<div class="flex-fill d-flex flex-column">
    <div *ngIf="partEdits" class="m-2 grid-fill">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [dataSource]="partEdits"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChangedShared($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="partId" width="100" caption="PartId" ></dxi-column>
            <dxi-column dataField="part.partNumber" width="200" caption="Edited Part"></dxi-column>
            <dxi-column dataField="orderLineDetailId" width="100" caption="DetailId" ></dxi-column>
            <dxi-column dataField="orderLineDetail.orderLine.order.invoiceNumber" width="100" caption="Sales Order #"></dxi-column>
            <dxi-column dataField="orderLineDetail.orderLine.order.dealer.companyName" width="200" caption="Dealer"></dxi-column>
            <dxi-column dataField="orderLineDetail.orderLine.part.partNumber" width="200" caption="SalesOrder Part" ></dxi-column>
            <dxi-column dataField="sent" width="125" dataType="date" ></dxi-column>
            <dxi-column dataField="processed" width="125"></dxi-column>
            <dxi-column dataField="isSent" width="125"></dxi-column>
            <dxi-column dataField="isProcessed" width="125"></dxi-column>
            <dxi-column width="125"></dxi-column>

            <div *dxTemplate="let cell of 'poTemplate'">
                <a [routerLink]="[]" (click)="purchaseOrderDialog(cell.data.id)">{{ cell.value || '' }}</a>
            </div>
            <div *dxTemplate="let cell of 'partChildrenTemplate'">
                <a [routerLink]="[]" (click)="partChildrenDialog(cell.data)">{{ cell.value || '' }}</a>
            </div>

            <dxo-export *ngIf="!showAsDialog" [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-search-panel *ngIf="!showAsDialog" class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-selection [mode]="'multiple'"></dxo-selection>
            <dxo-state-storing [enabled]="!showAsDialog" type="localStorage" storageKey="part-bulk-edit-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-danger" (click)="submit()">Submit</button>
                <button class="btn btn-success ms-2" (click)="getData()">Refresh</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="partEdits" class="me-3"
                    ><strong
                        >{{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong></span
                >
            </div>
        </dx-data-grid>
    </div>
    <div>
        <dx-toast message="Changes Saved!" type="success" [displayTime]="500" [maxWidth]="300" [position]="'bottom right'" [(visible)]="isToastVisible"> </dx-toast>
    </div>
</div>
